<template>
  <div class="loader">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>

@keyframes translateDots{
  0%{
    transform: translateX(0);
    opacity: 0;
  }
  50%{
    transform: translateX(50%);
    opacity: 1;
  }
  100%{
    transform: translateX(100%);
    opacity: 0;
  }
}

.loader{
  position:relative;
  height:auto;
  max-width: 600px;
  width: 100%;
  display:flex;
  padding-top: 10px;
  padding-bottom: 10px;
}
.loader > div{
  height:15px;
  width:15px;
  background:rgb(9, 37, 196);
  border-radius:50%;
  animation: translateDots 2.5s ease-in-out infinite;
  opacity:0;
}
.loader > div:nth-child(2){
  animation-delay:0.3333s;
}
.loader > div:nth-child(3){
  animation-delay:0.7777s;
}
.loader > div:nth-child(4){
  animation-delay:1s;
}
.loader > div:nth-child(5){
  animation-delay:1.4444s;
}
</style>
